import { createContext, ReactNode } from 'react';

export const ConfirmationContext = createContext({
  confirm: (title: ReactNode, confirmMessage: ReactNode, okLabel?: string) => Promise.resolve(),
});
